import React from 'react';
import { ProgressCircular } from 'react-onsenui';

export default function Loading() {
  return (
    <div className="c-loading">
      <ProgressCircular indeterminate/>
    </div>
  );
}